<template>
  <b-table-simple
    bordered
    responsive
    sticky-header
    class="mt-2"
    style="max-height: 65vh; font-size: 12px;"
  >
    <colgroup>
      <col style="width: 120px">
      <col style="width: 120px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
      <col style="width: 100px">
    </colgroup>
    <b-thead head-variant="light">
      <b-tr>
        <b-th
          rowspan="2"
          style="text-align: center;"
        >지역</b-th>
        <b-th
          rowspan="2"
          style="text-align: center;"
        >진료과</b-th>
        <b-th
          colspan="3"
          style="text-align: center;"
        >라이브 DI 노출 수</b-th>
        <b-th
          colspan="3"
          style="text-align: center;"
        >라이브 DI 클릭 수</b-th>
      </b-tr>
      <b-tr>
        <b-th
          style="text-align: center; top: 40px;"
        >전체</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의사 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의원 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >전체</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의사 수</b-th>
        <b-th
          style="text-align: center; top: 40px;"
        >의원 수</b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <template v-if="!gridVisible">
        <tr>
          <td
            colspan="8"
            style="text-align: center;"
          >
            라이브 DI 업데이트로 2025-08-28 이전 데이터는 제공되지 않습니다.
          </td>
        </tr>
      </template>
      <template v-else-if="data.length > 0">
        <template v-for="(region, rIdx) in data">
          <template v-for="(dept, dIdx) in region.liveDiDepts">
            <b-tr
              :key="`cumulative-${rIdx}-${dIdx}`"
              :style="region.regionName === '(미분류제외) 전체 합' ? 'background-color: rgba(127, 127, 255, 0.1);' : ''"
            >
              <b-td
                v-show="dIdx === 0"
                :rowspan="(region.liveDiDepts.length) + 1"
                style="text-align: center;"
              >
                {{ /*지역*/ region.regionName }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*진료과*/ dept.medicalDepartmentName }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*전체*/ dept.liveDiStatDetail.totalShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의사수*/ dept.liveDiStatDetail.doctorShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의원수*/ dept.liveDiStatDetail.hcpShowCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*전체*/ dept.liveDiStatDetail.totalClickCount | $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의사수*/ dept.liveDiStatDetail.doctorClickCount| $numberFormatter }}
              </b-td>
              <b-td
                style="text-align: center;"
              >
                {{ /*의원수*/ dept.liveDiStatDetail.hcpClickCount | $numberFormatter }}
              </b-td>
            </b-tr>
          </template>
          <b-tr
            :key="`cumulative-subtotal-${rIdx}`"
            class="h6 font-weight-bolder"
            style="background-color: rgba(127, 255, 127, 0.1);"
          >
            <b-td
              v-if="useSubTotal"
              style="text-align: center;"
            >
              {{ /*지역별 합계*/ region.regionName === '(미분류제외) 전체 합' ? '전체 합계' : '지역별 소계' }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 전체*/ region.subTotal.totalShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 의사수*/ region.subTotal.doctorShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 노출 의원수*/ region.subTotal.hcpShowCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 전체*/ region.subTotal.totalClickCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 의사수*/ region.subTotal.doctorClickCount | $numberFormatter }}
            </b-td>
            <b-td
              style="text-align: center;"
            >
              {{ /*합계 클릭 의원수*/ region.subTotal.hcpClickCount | $numberFormatter }}
            </b-td>
          </b-tr>
        </template>
      </template>
      <template v-else>
        <tr>
          <td
            colspan="8"
            style="text-align: center;"
          >
            라이브 DI를 선택해 주세요.
          </td>
        </tr>
      </template>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import {
  BTableSimple, BThead, BTr, BTh, BTbody, BTd,
} from 'bootstrap-vue'
import { onMounted } from '@vue/composition-api'

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    gridVisible: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    onMounted(() => {
    })

    const useSubTotal = true
    const useMainTotal = true
    const totalLevel = parseInt(useSubTotal + useMainTotal, 10)

    return {
      totalLevel,
      useSubTotal,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}
</style>
